export enum SURVEY_TYPES {
    FREEFORM = 'freeform',
    RATING = 'rating',
    SCALE = 'scale',
    BOOLEAN = 'boolean',
    MULTIPLE = 'multiple',
}
